import { ACTIVITY_LEVELS, GOAL_TYPES, MIN_DAILY_KCAL, } from './nutrition.js';
/** Базовый обмен по формуле Миффлина - Сан Жеора (ккал/сутки). */
export function basalMetabolicRate(p) {
    const base = 10 * p.weightKg + 6.25 * p.heightCm - 5 * p.ageYears;
    return p.sex === 'male' ? base + 5 : base - 161;
}
/** Суточный расход с учётом активности. */
export function totalDailyEnergyExpenditure(p) {
    return basalMetabolicRate(p) * ACTIVITY_LEVELS[p.activityLevel];
}
/**
 * Норма калорий и БЖУ под цель.
 *
 * Белок задаётся от массы тела (1.6 г/кг при похудении - чтобы удержать мышцы,
 * 1.4 г/кг иначе), жир - 25 % калорийности, остаток калорий уходит в углеводы.
 */
export function macroTargets(p) {
    const kcal = Math.max(MIN_DAILY_KCAL[p.sex], Math.round(totalDailyEnergyExpenditure(p) * (1 + GOAL_TYPES[p.goalType])));
    const proteinG = Math.round(p.weightKg * (p.goalType === 'lose' ? 1.6 : 1.4));
    const fatG = Math.round((kcal * 0.25) / 9);
    const carbsG = Math.max(0, Math.round((kcal - proteinG * 4 - fatG * 9) / 4));
    return { kcal, proteinG, fatG, carbsG };
}
/** Пересчёт нутриентов со 100 г на фактически съеденную порцию. */
export function scaleNutrients(per100g, grams) {
    const k = grams / 100;
    const round = (v) => Math.round(v * 10) / 10;
    return {
        kcal: Math.round(per100g.kcal * k),
        protein: round(per100g.protein * k),
        fat: round(per100g.fat * k),
        carbs: round(per100g.carbs * k),
    };
}
//# sourceMappingURL=calc.js.map